<template>
  <div>
    <loading :active.sync="this.$store.state.loading.isLoading" dusk="loading"></loading>

    <header>
      <Navbar/>
    </header>

    <div class="container py-4">
      <breadcrumb :breadcrumbs="breadcrumbs"/>

      <!-- キャッシュするコンポーネント内でnameに設定された値をカンマ区切りで設定 -->
      <keep-alive include="index">
        <router-view/>
      </keep-alive>

      <div v-if="this.$store.state.backButton.to" class="text-right">
        <router-link :to="this.$store.state.backButton.to" class="btn btn-success">戻る</router-link>
      </div>
    </div>

    <!-- 広告コンバージョンタグ実行用外部ページ呼び出しiframe -->
    <iframe v-if="iframeUrl" :src="iframeUrl" style="display: block; height: 1px; width: 1px; border: none"></iframe>
  </div>
</template>

<style>
/*ボタンラベル文字中の改行を禁止*/
.btn {
  white-space: nowrap;
}

/* VuejsDialog オーバーライド*/
.dg-btn {
  min-width: 30%;
  font-weight: inherit;
  font-size: inherit;
}

.dg-btn--ok {
  color: #fff;
  background-color: #2fa360;
  border-color: #2d995b;
}

.dg-btn--cancel {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.dg-title {
  font-weight: bold;
}

/* Toasted オーバーライド*/
.toasted {
  font-size: 1.5em !important;
}

/* 成功ダイアログのみセンタリングを行う */
.toasted.success {
  text-align: center;
}

/* flexコンテナとなっておりセンタリングされないためブロックに変更 */
.toasted-container .toasted {
  display: block;
}
</style>

<script>
import Navbar from "./components/Navbar";
import Breadcrumb from './components/Breadcrumb.vue';
import {
  NOT_FOUND,
  UNAUTHORIZED,
  INTERNAL_SERVER_ERROR,
  UNPROCESSABLE_ENTITY,
  TOO_MANY_REQUESTS,
  PAGE_EXPIRED
} from '../utils';
import * as Sentry from "@sentry/browser";

export default {
  components: {
    Navbar,
    Breadcrumb,
  },
  data: function () {
    return {
      breadcrumbs: this.$route.meta.breadcrumbs
    }
  },
  computed: {
    errorCode() {
      return this.$store.state.error.code;
    },
    iframeUrl() {
      return this.$store.state.iframe.url;
    },
  },
  watch: {
    errorCode: {
      async handler(val) {
        if (val === INTERNAL_SERVER_ERROR) {
          // Sentryにエラーを送信
          Sentry.captureMessage(val);

          this.$router.push('/member/500');
        } else if (val === UNAUTHORIZED || val === PAGE_EXPIRED) {
          // CSRFトークンリフレッシュ
          await axios.get('/api/refresh-token');
          // ストアのuserをクリア
          this.$store.commit('auth/setUser', null);
          // ログイン画面を表示
          this.$router.replace({
                path: '/member/login',
                query: {redirect: this.$route.fullPath}
              }
          )
        } else if (val === NOT_FOUND) {
          // Sentryにエラーを送信
          Sentry.captureMessage(val);

          this.$router.push('/member/not-found')
        } else if ((val === UNPROCESSABLE_ENTITY) || (val === TOO_MANY_REQUESTS)) {
          // noop
        } else if (val != null) {
          // Sentryにエラーを送信
          Sentry.captureMessage(val);

          let msg = 'undefined http status code: ' + val;
          console.log(msg);
          alert(msg);
        }
      },
      immediate: true
    },
    '$route'(to) {
      this.breadcrumbs = to.meta.breadcrumbs;
      this.$store.commit("backButton/setTo", false);
    },
  }
}
</script>


